// Mobile sidebar dropdown functionality
document.addEventListener("DOMContentLoaded", function () {
	const dropdown = document.getElementById("mobileSidebarDropdown");
	const dropdownBtn = document.getElementById("mobileSidebarDropdownBtn");
	const dropdownMenu = document.getElementById("mobileSidebarDropdownMenu");

	if (dropdownBtn && dropdownMenu) {
		function isOpen() {
			return dropdownBtn.getAttribute("aria-expanded") === "true";
		}

		function openDropdown() {
			dropdownBtn.setAttribute("aria-expanded", "true");
			dropdownMenu.removeAttribute("hidden");
		}

		function closeDropdown() {
			dropdownBtn.setAttribute("aria-expanded", "false");
			dropdownMenu.setAttribute("hidden", "");
			closeCategoryDropdowns();
		}

		function toggleDropdown() {
			if (isOpen()) {
				closeDropdown();
			} else {
				openDropdown();
			}
		}

		dropdownBtn.addEventListener("click", function (e) {
			e.preventDefault();
			e.stopPropagation();
			toggleDropdown();
		});

		document.addEventListener("click", function (e) {
			if (isOpen() && dropdown && !dropdown.contains(e.target)) {
				closeDropdown();
			}
		});

		document.addEventListener("keydown", function (e) {
			if (e.key === "Escape" && isOpen()) {
				closeDropdown();
			}
		});

		dropdownMenu.querySelectorAll("a").forEach(function (link) {
			link.addEventListener("click", function () {
				closeDropdown();
			});
		});

		window.addEventListener("resize", function () {
			if (window.innerWidth >= 768 && isOpen()) {
				closeDropdown();
			}
		});
	}

	const filterStorageKey = "mnd.sidebarHideCategoryFilters";
	const selectedStorageKey = "mnd.sidebarSelectedCategories";
	const roots = document.querySelectorAll("[data-sidebar-root]");
	const filterControls = document.querySelectorAll("[data-sidebar-filter-control]");
	if (!roots.length || !filterControls.length) {
		return;
	}

	function categoryKey(value) {
		return (value || "").trim().toLowerCase();
	}

	function uniqueCategories(values) {
		const result = [];
		(values || []).forEach(function (value) {
			const trimmed = (value || "").trim();
			if (!trimmed) {
				return;
			}

			if (!result.some(function (item) {
				return categoryKey(item) === categoryKey(trimmed);
			})) {
				result.push(trimmed);
			}
		});
		return result;
	}

	function parseCategoryList(value) {
		if (!value) {
			return [];
		}

		try {
			const parsed = JSON.parse(value);
			if (Array.isArray(parsed)) {
				return uniqueCategories(parsed.map(function (item) {
					return item == null ? "" : String(item);
				}));
			}
		} catch (error) {
			// Fall through to the legacy comma-separated format.
		}

		return uniqueCategories(value.split(","));
	}

	function availableCategories() {
		return uniqueCategories(Array.prototype.map.call(filterControls, function (control) {
			return control.getAttribute("data-category") || "";
		}));
	}

	function readStoredCategories() {
		try {
			return parseCategoryList(sessionStorage.getItem(selectedStorageKey));
		} catch (error) {
			return [];
		}
	}

	function writeStoredCategories(categories) {
		try {
			const unique = uniqueCategories(categories);
			if (!unique.length) {
				sessionStorage.removeItem(selectedStorageKey);
			} else {
				sessionStorage.setItem(selectedStorageKey, JSON.stringify(unique));
			}
		} catch (error) {
			// Ignore storage errors (private browsing, etc.)
		}
	}

	function isFilterHidden() {
		try {
			return localStorage.getItem(filterStorageKey) === "1";
		} catch (error) {
			return false;
		}
	}

	function setFilterHidden(hidden) {
		try {
			localStorage.setItem(filterStorageKey, hidden ? "1" : "0");
		} catch (error) {
			// Ignore storage errors (private browsing, etc.)
		}
	}

	function applyFilterVisibility(hidden) {
		roots.forEach(function (root) {
			if (root.getAttribute("data-sidebar-filter-mode") !== "pills") {
				return;
			}

			root.classList.toggle("sidebar-filters-hidden", hidden);
			root.querySelectorAll("[data-sidebar-category-filters]").forEach(function (filters) {
				filters.hidden = hidden;
			});
			root.querySelectorAll("[data-sidebar-filter-toggle]").forEach(function (button) {
				const label = button.querySelector("[data-sidebar-filter-label]");
				const text = hidden ? "Show filter" : "Hide filter";
				if (label) {
					label.textContent = text;
				} else {
					button.textContent = text;
				}
				button.setAttribute("aria-expanded", hidden ? "false" : "true");
			});
		});
	}

	function isControlSelected(control) {
		if (control.matches("input[type='checkbox']")) {
			return control.checked;
		}

		return control.classList.contains("selected");
	}

	function renderTag(tag, selected) {
		const category = tag.getAttribute("data-category") || "";
		tag.classList.toggle("selected", selected);
		tag.replaceChildren();
		if (selected) {
			const close = document.createElement("span");
			close.className = "me-1";
			close.textContent = "×";
			tag.appendChild(close);
		}
		tag.appendChild(document.createTextNode(category));
	}

	function setControlSelected(control, selected) {
		if (control.matches("input[type='checkbox']")) {
			control.checked = selected;
			return;
		}

		renderTag(control, selected);
	}

	function selectedCategories() {
		return uniqueCategories(Array.prototype.reduce.call(filterControls, function (selected, control) {
			if (isControlSelected(control)) {
				selected.push(control.getAttribute("data-category") || "");
			}
			return selected;
		}, []));
	}

	function persistSelectedCategories() {
		const available = availableCategories();
		const selected = selectedCategories();
		const preserved = readStoredCategories().filter(function (category) {
			return !available.some(function (item) {
				return categoryKey(item) === categoryKey(category);
			});
		});
		writeStoredCategories(preserved.concat(selected));
	}

	function clearCategoryFilter() {
		filterControls.forEach(function (control) {
			setControlSelected(control, false);
		});
		writeStoredCategories([]);
		applyCategoryFilter();
	}

	function applyCategoryFilter() {
		const selected = selectedCategories();

		filterControls.forEach(function (control) {
			const category = control.getAttribute("data-category") || "";
			const isSelected = selected.some(function (item) {
				return categoryKey(item) === categoryKey(category);
			});
			setControlSelected(control, isSelected);
		});

		document.querySelectorAll("[data-sidebar-page-list] li").forEach(function (item) {
			if (selected.length === 0) {
				item.classList.remove("is-filtered-out");
				return;
			}

			const categories = parseCategoryList(item.getAttribute("data-categories"));
			const matches = selected.some(function (category) {
				return categories.some(function (itemCategory) {
					return categoryKey(itemCategory) === categoryKey(category);
				});
			});

			item.classList.toggle("is-filtered-out", !matches);
		});
	}

	function restoreStoredCategories() {
		const stored = readStoredCategories();
		if (!stored.length) {
			return;
		}

		const available = availableCategories();
		filterControls.forEach(function (control) {
			const category = control.getAttribute("data-category") || "";
			const isSelected = stored.some(function (item) {
				return categoryKey(item) === categoryKey(category);
			}) && available.some(function (item) {
				return categoryKey(item) === categoryKey(category);
			});
			setControlSelected(control, isSelected);
		});
	}

	function closeCategoryDropdown(dropdownRoot) {
		const toggle = dropdownRoot.querySelector("[data-sidebar-category-dropdown-toggle]");
		const menu = dropdownRoot.querySelector("[data-sidebar-category-dropdown-menu]");
		if (toggle) {
			toggle.setAttribute("aria-expanded", "false");
		}
		if (menu) {
			menu.setAttribute("hidden", "");
		}
	}

	function closeCategoryDropdowns() {
		document.querySelectorAll("[data-sidebar-category-dropdown]").forEach(closeCategoryDropdown);
	}

	function openCategoryDropdown(dropdownRoot) {
		const toggle = dropdownRoot.querySelector("[data-sidebar-category-dropdown-toggle]");
		const menu = dropdownRoot.querySelector("[data-sidebar-category-dropdown-menu]");
		if (toggle) {
			toggle.setAttribute("aria-expanded", "true");
		}
		if (menu) {
			menu.removeAttribute("hidden");
		}
	}

	restoreStoredCategories();
	applyCategoryFilter();
	applyFilterVisibility(isFilterHidden());

	document.querySelectorAll("[data-sidebar-filter-toggle]").forEach(function (button) {
		button.addEventListener("click", function (event) {
			event.preventDefault();
			event.stopPropagation();
			const hidden = !isFilterHidden();
			setFilterHidden(hidden);
			applyFilterVisibility(hidden);
		});
	});

	document.querySelectorAll("[data-sidebar-clear-filter]").forEach(function (button) {
		button.addEventListener("click", function (event) {
			event.preventDefault();
			event.stopPropagation();
			clearCategoryFilter();
		});
	});

	filterControls.forEach(function (control) {
		const eventName = control.matches("input[type='checkbox']") ? "change" : "click";
		control.addEventListener(eventName, function (event) {
			if (!control.matches("input[type='checkbox']")) {
				event.preventDefault();
			}
			event.stopPropagation();
			const category = control.getAttribute("data-category") || "";
			const selected = control.matches("input[type='checkbox']")
				? control.checked
				: !control.classList.contains("selected");

			filterControls.forEach(function (item) {
				if (categoryKey(item.getAttribute("data-category") || "") === categoryKey(category)) {
					setControlSelected(item, selected);
				}
			});

			persistSelectedCategories();
			applyCategoryFilter();
		});
	});

	document.querySelectorAll("[data-sidebar-category-dropdown-toggle]").forEach(function (toggle) {
		toggle.addEventListener("click", function (event) {
			event.preventDefault();
			event.stopPropagation();
			const dropdownRoot = toggle.closest("[data-sidebar-category-dropdown]");
			if (!dropdownRoot) {
				return;
			}

			const isExpanded = toggle.getAttribute("aria-expanded") === "true";
			closeCategoryDropdowns();
			if (!isExpanded) {
				openCategoryDropdown(dropdownRoot);
			}
		});
	});

	document.addEventListener("click", function (event) {
		document.querySelectorAll("[data-sidebar-category-dropdown]").forEach(function (dropdownRoot) {
			if (!dropdownRoot.contains(event.target)) {
				closeCategoryDropdown(dropdownRoot);
			}
		});
	});

	document.addEventListener("keydown", function (event) {
		if (event.key === "Escape") {
			closeCategoryDropdowns();
		}
	});
});
